import { render, staticRenderFns } from "./GridForm.vue?vue&type=template&id=3058b43e"
import script from "./GridForm.vue?vue&type=script&lang=js"
export * from "./GridForm.vue?vue&type=script&lang=js"
import style0 from "./GridForm.vue?vue&type=style&index=0&id=3058b43e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports